export default __webpack_public_path__ + "static/media/metro_tx_school_districts_labeled_corrected.8e81d965.geojson";